import React, { useEffect } from "react";
import AnaVatanPageContent from "../../components/anaVatan/content";
import RootLayout from "../layout";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../../redux/Slices/loading.slice";
import PageLayout from "../../components/layout/PageLayout";
import { useShowcaseCacheWithConfig } from "../../utils/hooks/useShowcaseCache";

const AnaVatanPage = () => {
  const dispatch = useDispatch();
  
  const { data, loading } = useShowcaseCacheWithConfig({
    cacheKey: "anavatan",
    configKey: "anvatanHome",
    versionTitle: "anavatan",
  });

  // Handle loading state for sidebar
  useEffect(() => {
    if (loading) {
      dispatch(startLoading("در حال بارگذاری آناوطن..."));
    } else {
      dispatch(stopLoading());
    }
  }, [loading, dispatch]);

  return (
    <RootLayout>
      <PageLayout loading={loading} skeletonType="anavatan">
        {data && <AnaVatanPageContent showCaseData={data} />}
      </PageLayout>
    </RootLayout>
  );
};

export default AnaVatanPage;

